<template>
  <div class="container-fluid">
    <page-header
      :page="page"
      has-return
      left-side-class="col-xl-8"
      right-side-class="col-xl-4 d-flex align-items-end justify-content-end pb-2"
    >
    </page-header>

    <InformationHeader
      v-if="model.id"
      ref="InformationHeader"
      :request-id="model.id"
      :assistant-type-id="model.assistantTypeId"
      :status-id="model.statusId"
      :get-information-header="getInformationHeader"
      :request-status-string="{}"
    />

    <ValidationObserver ref="main-form">
      <div
        class="cursor--pointer"
        aria-expanded="true"
        aria-controls="collapseOne"
        @click="toggleExpand"
      >
        <div class="accordion-header-container">
          <div class="collapse-title d-flex">
            <span
              class="bg-light-gray my-3 p-2 mr-2 radius-20 font-weight-bold"
            >
              <span class="bg-white p-1 radius-100">
                <i
                  class="fal fa-lg"
                  :class="{
                    'fa-chevron-circle-right orange-icon': !getIsExpanded,
                    'fa-chevron-circle-down text-success': getIsExpanded,
                  }"
                />
              </span>
              Proceso realizado previo a Solicitud de Personal Irregular
            </span>
          </div>
        </div>
      </div>

      <div
        id="collapseOne"
        :key="'options'"
        :class="{
          'collapse mt-2': !getIsExpanded,
          'collapse show mt-2': getIsExpanded,
        }"
        aria-labelledby="headingOne"
      >
        <OrderedHeader order="1">
          <template v-slot:content>
            ¿Usted cuenta con el documento de la SAEE-10?
          </template>
          <template v-slot:actions>
            <CustomRadio
              is-question-list
              custom-error-msg=""
              class="ordered-header-card-custom-radio"
              :name="'rbQuestion-1'"
              :options="getYesNoOptions"
              :disabled="isReadOnly"
            />
          </template>
          <template
            v-if="model.facilitatorDiscussionOccurred"
            v-slot:content-bottom
          >
            <div class="row p-3">
              <div class="col-md-5 col-sm-12 mb-3">
                <ValidationProvider
                  v-slot="{ errors }"
                  name="Año académico"
                  rules="required"
                >
                  <label class="input-label">Año académico:</label>
                  <CustomDropDown
                    v-model="model.academicYear"
                    placeholder="Seleccione"
                    fieldkey="id"
                    fieldname="name"
                    :options="collections.academicYears"
                    :error="errors[0]"
                    :disabled="isReadOnly"
                  />
                  <CustomError
                    v-if="errors[0]"
                    variant="no-border"
                    message="Favor seleccione año académico."
                  />
                </ValidationProvider>
              </div>
              <template>
                <div class="col-12 mt-2">
                  <label class="input-label">Justificación:</label>
                  <ValidationProvider
                    v-slot="{ errors }"
                    name="description"
                    :rules="'required'"
                  >
                    <CustomTextArea
                      :id="'description'"
                      v-model="model.facilitatorDiscussionDescription"
                      style="width: 100%"
                      :maxlength="3000"
                      :classes="['eq-field', 'text-right']"
                      :rows="5"
                      :error="errors[0]"
                      :custom-error-msg="'Favor escriba una descripción.'"
                      :disabled="isReadOnly"
                    />
                  </ValidationProvider>
                </div>
                <div class="col-12 col-md-6 mt-2">
                  <label class="input-label">Documento:</label>
                  <p class="document-name">
                    {{
                      model.facilitatorDiscussionEvidenceDocument
                        .documentTypeName
                    }}
                  </p>
                </div>
                <div class="col-12 col-md-6 mt-2">
                  <ValidationProvider
                    v-slot="{ errors }"
                    name="Archivo"
                    :rules="'required'"
                  >
                    <CustomFileInput
                      :attachment-id="model.studentList[0].lastSignedPei"
                      :name="
                        model.facilitatorDiscussionEvidenceDocument.filename
                      "
                      label="Archivo:"
                      :accept="'.pdf'"
                      display-style="normal"
                      label-position="left"
                      :max-size="10"
                      :error="errors[0]"
                      :custom-error-msg="
                        errors[0] ? 'Favor anejar un documento.' : ''
                      "
                      :disabled="isReadOnly"
                      :on-download="buildSAEE10Report"
                    />
                  </ValidationProvider>
                </div>
              </template>
            </div>
          </template>
        </OrderedHeader>
      </div>

      <div
        v-if="model.facilitatorDiscussionOccurred"
        class="row mt-4 mt-lg-5"
        :class="{ collapse: !getIsExpanded, 'collapse show': getIsExpanded }"
      >
        <div class="col-lg-5 pr-lg-0">
          <div class="d-flex align-items-center bg-light-gray-f2 h-100">
            <span class="font-weight-bold m-3">
              La solicitud de personal irregular es para:
            </span>
          </div>
        </div>
        <div class="col-lg-7 pl-lg-1">
          <ValidationProvider
            v-slot="{ errors }"
            name="Tipo solicitud"
            rules="required"
          >
            <CustomRadio
              is-question-list
              class="radio-icon"
              :value="model.assistantTypeId"
              :name="'tipoSolictud'"
              :error="!!errors[0]"
              :custom-error-msg="
                !!errors[0] ? 'Favor seleccionar el tipo de solicitud.' : ''
              "
              :options="getRequestTypeOptions(!!errors[0])"
              :disabled="isReadOnly"
            />
          </ValidationProvider>
        </div>
      </div>

      <div
        v-if="model.facilitatorDiscussionOccurred"
        class="row mt-4 mt-lg-5 mb-lg-5"
        :class="{ collapse: !getIsExpanded, 'collapse show': getIsExpanded }"
      >
        <div class="col">
          <div class="d-flex align-items-center bg-light-gray-f2 h-100">
            <ul class="fa-ul pt-3 pb-3 text-muted">
              <li
                v-for="item in getRequestTypeOptions()"
                :key="item.id"
                class="p-2"
              >
                <span class="fa-li"><i :class="item.icon" /></span>
                <span class="font-weight-bold">{{ item.label }}</span>
                : {{ item.description }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </ValidationObserver>

    <custom-tab
      v-if="model.id"
      ref="request-tabs"
      :no-nav-style="true"
      nav-class="nav-vue-underline"
    >
      <custom-tab-item
        :lazy="false"
        :title="requestTypeTabTitle"
        :active="true"
      >
        <RequestInformation
          ref="informationForm"
          :canShowSignaturePanel="false"
          v-model="model"
          :collections="collections"
          :is-read-only="isReadOnly"
          :can-show-necessity-sub-sections="false"
        />
      </custom-tab-item>
    </custom-tab>
  </div>
</template>

<script>
import PageHeader from "PageHeader";
import ActionButton from "ActionButton";
import CustomRadio from "custom-radio";
import CustomDropDown from "custom-drop-down";
import CustomTextArea from "CustomTextArea";
import CustomFileInput from "CustomFileInput";
import CustomError from "custom-error";
import OrderedHeader from "ordered-header-card";
import { CustomTab, CustomTabItem } from "custom-tabs";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import alert from "@/mixin/alert.mixin";
import academicService from "@/services/api/academicUtils.api";
import resourcesService from "@/services/resources";
import documentsService from "@/services/documents";
import generalService from "@/services/pei/general";
import requestDocumentTypeCodes from "@/utils/constants/hrrequest/requestDocumentTypeCodes";
import requestTypeOptions from "@/utils/constants/hrrequest/requestTypeOptions";
import necessityCodes from "@/utils/constants/hrrequest/necessityCodes";
import yesNoOptions from "@/utils/constants/hrrequest/yesNoOptions";
import EduEspCode from "@/utils/constants/eduEspCode";
import InformationHeader from "../request/components/InformationHeader";
import RequestInformation from "../request/components/tabs/tab1RequestInformation";
import { getNecessitiesList } from "@/modules/human-resources/api";
import { getInformationHeader, getSAEE10Data, getIfHasSubmittedInfo } from "@/modules/peiSAEE/api";

const modelInitialState = () => ({
  id: 0,
  statusId: 0,
  assistantTypeId: null,
  academicYear: null,
  facilitatorDiscussionOccurred: false,
  facilitatorDiscussionDescription: null,
  facilitatorDiscussionEvidenceDocument: {
    file: null,
    filename: 'SAEE-10',
    attachmentId: null,
    documentTypeName: null,
  },
  custodian: null,
  student: null,
  studentSIE: null,
  studentList: [],
  necessities: [],
  documents: [],
});

export default {
  name: "HumanResourcesIrregularStaffRequestNecessitiesReview",
  mixins: [alert],
  components: {
    ValidationObserver,
    ValidationProvider,
    PageHeader,
    ActionButton,
    OrderedHeader,
    CustomError,
    CustomRadio,
    CustomDropDown,
    CustomTextArea,
    CustomFileInput,
    CustomTab,
    CustomTabItem,
    InformationHeader,
    RequestInformation,
  },
  data: () => ({
    page: {
      icon: "fas fa-user-edit",
      title: "Solicitud de Personal Irregular",
      routes: ["Inicio", "Recursos Humanos", "Personal Irregular"],
    },
    isExpanded: true,
    model: modelInitialState(),
    servicessNeedsId:[],
    collections: {
      resources: [],
      academicYears: [],
      necessities: [],
      resourceTypes: [],
      documentTypes: [],
      regions: [],
      municipalities: [],
      schools: [],
      servicessNeeds:[],
      paramActivateAssistantServiceNeedGuideWasOn:false,
      hygieneStudent: { id: necessityCodes.hygiene, list: [] },
      feedingStudent: { id: necessityCodes.feeding, list: [] },
      mobilityStudent: { id: necessityCodes.movility, list: [] },
      communicationStudent: { id: necessityCodes.comunication, list: [] },
      healthStudent: { id: necessityCodes.health, list: [] },
      transportationStudent: { id: necessityCodes.transportation, list: [] },
      othersStudent: { id: necessityCodes.others, list: [] },
      peiId: null
    },
    requestId: null,
  }),
  computed: {
    requestTypeTabTitle() {
      let result = "Solicitud";
      const requestType = requestTypeOptions.find(
        (rt) => rt.id == this.model.assistantTypeId
      );
      if (requestType) result += ` de ${requestType.label}`;
      return result;
    },
    getYesNoOptions() {
      return yesNoOptions.map((op) => ({
        ...op,
        check: this.model.facilitatorDiscussionOccurred == op.id,
        disabled: this.isReadOnly,
      }));
    },
    getRequestTypeOptions() {
      return (isValid) =>
        requestTypeOptions.map((op) => ({
          ...op,
          check: this.model.assistantTypeId == op.id,
          invalid: isValid,
          disabled: this.isReadOnly,
        }));
    },
    getIsExpanded() {
      return this.isExpanded;
    },
    isReadOnly() {
      return true;
    },
  },
  methods: {
    getInformationHeader,
    async setModelInitialState({ data }) {
      this.mapRequestData(data);
      this.model.id = data.requestId;
      this.model.statusId = data.statusId;
      this.model.facilitatorDiscussionOccurred =
        data.facilitatorDiscussionOcurred;
      this.model.facilitatorDiscussionDescription =
        data.facilitatorDiscussionDescription;
      this.model.assistantTypeId = data.assistantTypeId.toString();
      this.model.contactPhone = data.contactNumber;
      this.model.date = data.date;
      this.model.necessities = data.necessities;
      this.model.studentList = data.students;
      this.model.assistant = data.assistantId;
      this.model.schoolHasAssistantsAvailable = data.schoolHasAssistantsAvailable;
      this.servicessNeedsId = data.servicesNeedsId;
      if(data.schoolAssistants){
        this.model.schoolAssistants = data.schoolAssistants.map(assistant => ({
          assistantName: {
            name: assistant.assistantName
          },
          resourceType: {
            name: '',
          },
          dailyShift: {
            name: '',
          },
        }));
      }
            
      this.model.academicYear = this.collections.academicYears.find(
        (academicYear) => academicYear.id == data.academicYearId
      );
    },
    mapRequestData(data) {
      data.necessities.forEach((necessity) => {
        const foundNecessity = this.collections.necessities.find(
          (n) => n.id == necessity.necessityId
        );
        necessity.name = foundNecessity?.name; //se añadio para evitar romper pantalla con err de undefined cuando una necesidad no tiene categoria
        necessity.studentNecessities.forEach((studentNecessity) => {
          studentNecessity.student = data.students.find(
            (s) => s.studentSie == studentNecessity.studentSieId
          );
          studentNecessity.name = studentNecessity.student.name;
          studentNecessity.assistantTypes =
            studentNecessity.assistantTypesId.map((assistantTypeId) => {
              return studentNecessity.student.serviceNeeds
                .filter((sn) => sn.id == assistantTypeId)
                .map((sn) => ({
                  id: sn.id,
                  name: sn.spaShortDescription,
                }))
                .find((x) => x);
            });
        });
      });
    },
    setPrincipalDocumentTypeName() {
      const documentType = this.collections.documentTypes.find(
        (docType) =>
          docType.id ===
          requestDocumentTypeCodes.EvidenciaPreConsultaPersonalIrregularAlFacilitador
      );
      if (documentType)
        this.model.facilitatorDiscussionEvidenceDocument.documentTypeName =
          documentType.name;
    },
    toggleExpand() {
      this.isExpanded = !this.isExpanded;
    },
    async getStudentInfo(){
       this.getInformationHeader(this.model.id).then((studentInfo)=>{
        const { data } = studentInfo
        this.collections.studentId = data.studentSie
       });
    },
    downloadFile(attachmentId) {
      return documentsService.downloadFromServer(attachmentId);
    },
    async buildSAEE10Report(peiId) {
      try {
        const { data } = await this.$ApiGet(`/api/report/saee10/${peiId}`);
        await generalService.documentDownloadReport(
          data.content,
          data.filename
        );
      } catch (error) {
        this.ShowToast(
          "",
          "Ocurrio un problema al descargar el reporte, vuelve a intentarlo.",
          "error"
        );
      }
    },
    async fetchDropDownsData() {
      const resultAcademicYears =
        await academicService.getHRrequestAcademicYears();
      this.collections.academicYears = resultAcademicYears.map(
        (academicYear) => ({
          ...academicYear,
          name: academicYear.description,
        })
      );
      const resultNecesities = await getNecessitiesList();
      this.collections.necessities = resultNecesities.data.map((necessity) => ({
        ...necessity,
        selected: false,
      }));
      const resultResourceType = await academicService.getEduEsp({
        codetype: EduEspCode.ResourceType,
      });
      this.collections.resourceTypes = resultResourceType.data;
    },
    async fetchResources() {
      const resultDocumentTypes = await documentsService.getDocumentTypes(
        "HRRequest"
      );
      this.collections.documentTypes = resultDocumentTypes.data;
      this.collections.resources =
        await resourcesService.LoadValidationMessages([
          "R01210001",
          "R01210002",
          "R01210003",
          "R01210004",
          "R9260053",
        ]);
    },
    async getSAEE10Data(saee10Id) {
      await getSAEE10Data(saee10Id).then(this.setModelInitialState).catch();
    },
    async getServicesNeeds(){
      let peiId = this.model.studentList[0].lastSignedPei
      this.collections.peiId = peiId;
      const HasSubmittedInfo = await getIfHasSubmittedInfo(peiId);

      const { data: needs } = await generalService.getSelectedPeiServiceNeed(
          peiId
        );
      const filteredData = needs.filter(item => this.servicessNeedsId.includes(item.id));
      this.collections.servicessNeeds = filteredData;
      this.collections.paramActivateAssistantServiceNeedGuideWasOn = HasSubmittedInfo.data;
    }
  },
  async mounted() {
    await this.fetchDropDownsData();
    await this.fetchResources();
    if (this.$route.params.id) {
      await this.getSAEE10Data(this.$route.params.id);
    }
    await this.getStudentInfo();
    this.setPrincipalDocumentTypeName();
    await this.getServicesNeeds();
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables/_colors.scss";
.bg-light-gray-f2 {
  background-color: #f7f7f7;
}
.orange-icon {
  color: #ff7058;
}
.document-name {
  font: normal normal normal 16px/20px Lato;
  letter-spacing: 0px;
  color: #11291b;
  opacity: 1;
}
.radius-20 {
  border-radius: 20px;
}
.radius-100 {
  border-radius: 100%;
}
.div-error {
  background: #feeaea;
  padding: 20px;
}
.div-error p {
  color: #c9545e;
  font: normal normal normal 16px/19px Lato;
  border-radius: 0px 0px 5px 5px;
}
::v-deep .custom-tab-container {
  margin-bottom: 20px;
}
::v-deep .read-only .input-display > label {
  color: $gray_6 !important;
  margin-bottom: 5px !important;
}
::v-deep #dropdownMenuButton {
  background-color: transparent !important;
  color: black !important;
}
</style>
